﻿'use strict';

angular.module('ntmApp').factory('DailyRecurrence', ['Recurrence', 'Constants', function (Recurrence, Constants) {

    function DailyRecurrence() {
        Recurrence.call(this);

        var self = this;

        self.displaySchedulingLeeway = function () {
            return false;
        };

        self.displayOccurenceLimit = function () {
            return true;
        };

        self.displaySchedulingSettings = function () {
            return 'ng1/src/setup/recurrence/templates/daily-scheduling-settings.html';
        };

        self.hideStartsOnDateBasedOnConditions = function () {
            return false;
        };

        self.getFieldsListForSave = function () {
            var fieldsList = self.getGeneralFieldsListForSave();

            fieldsList.startsOnDate = self.startsOnDate;

            if ((fieldsList.startsOnDate && fieldsList.startsOnDate.value) && (fieldsList.occurenceLimitEndsOnDate && fieldsList.occurenceLimitEndsOnDate.value)) {
                fieldsList.dateStartAndDateEnd = [{ dateStart: self.startsOnDate, dateEnd: self.occurenceLimitEndsOnDate }];
            }

            return fieldsList;
        };

        self.getRequestData = function () {

            var request = self.getGeneralRequestData();

            request.dateStart = self.startsOnDate.value;

            return request;
        };

        self.applyDefaultInfo = function (data) {
            self.applyGeneralDefaultInfo(data);
        };

        self.checkForDynamicRestricts = function (field, fieldName) {

            switch (fieldName) {
                case 'startsOnDate':
                    field.restricts.allowNullable = true;

                    break;
                default:
                    break;
            }
        };

        self.equals = function (recurrence) {

            if (!self.compareGeneralInfo(recurrence)) {
                return false;
            }

            if (!self.areDaysEqual(self.startsOnDate.value, recurrence.startsOnDate.value)) {
                return false;
            }

            if (!self.areDaysEqual(self.occurenceLimitEndsOnDate.value, recurrence.occurenceLimitEndsOnDate.value)) {
                return false;
            }

            return true;
        };

        function initialize() {
            self.patternType = Constants.Recurrence.Patterns.DAILY.value;
            self.datePickerOptions = { datepickerMode: 'day', minMode: 'day', templateString: 'MMMM d, y' };
        }

        initialize();
    }

    DailyRecurrence.prototype = Object.create(Recurrence.prototype);
    DailyRecurrence.prototype.constructor = Recurrence;

    return (DailyRecurrence);

}]);